"use client"
import { useState } from "react"
import { Mail, Send } from "lucide-react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs"
import { TemplateManager } from "./template-manager"
import { TemplateEmailSender } from "./template-email-sender"

export function EnhancedEmailTools({ allUsers, adminUsers, portals, bioDataList }: any) {
  const [activeTab, setActiveTab] = useState("send")

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Email & Template System</h1>
        <p className="text-gray-600 mt-2">Manage templates and send beautiful, personalized emails</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="send" className="gap-2">
            <Send className="h-4 w-4" />
            Send Email
          </TabsTrigger>
          <TabsTrigger value="templates" className="gap-2">
            <Mail className="h-4 w-4" />
            Templates
          </TabsTrigger>
        </TabsList>

        <TabsContent value="send" className="space-y-6">
          <TemplateEmailSender
            allUsers={allUsers}
            adminUsers={adminUsers}
            portals={portals}
            bioDataList={bioDataList}
          />
        </TabsContent>

        <TabsContent value="templates" className="space-y-6">
          <TemplateManager />
        </TabsContent>
      </Tabs>
    </div>
  )
}
